import { fg } from '@atlaskit/platform-feature-flags';

// https://switcheroo.atlassian.com/ui/gates/rovo-fps-3p-ux-salesforce-lead-noun
export default {
	get(): boolean {
		return fg('rovo-fps-3p-ux-salesforce-lead-noun');
	},
};
